The input parameter for the `uploadCandidate` mutation.
